// extracted by mini-css-extract-plugin
export default {"fields":"SalesforceSettingsFields_fields__3pLBh","resetButton":"SalesforceSettingsFields_resetButton__kNqLQ"};